import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomatherancabs() {



const cardData =
{
  keyword: 'Pune to Matheran Cabs',

  heading: 'Lotus Cab: Pune to Matheran Cabs',

headingDescription:
    "Lotus Cabs offers reliable and affordable Pune to Matheran Cabs for family vacations, weekend getaways, honeymoon trips, sightseeing tours, corporate outings, and one-way or round-trip travel. We provide a premium fleet of Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus driven by professional and experienced chauffeurs. With 24x7 booking support, transparent pricing, doorstep pickup anywhere in Pune, well-maintained vehicles, and safe travel through the scenic Western Ghats, Lotus Cabs ensures a comfortable, enjoyable, and hassle-free journey to the beautiful hill station of Matheran.",


  top: 'Top Places to Visit in Matheran with Lotus Cab',

 topPlaces: [
    {
        title: "Charlotte Lake",
        description:
            "Charlotte Lake is one of Matheran's most famous attractions and serves as a peaceful retreat surrounded by lush forests and rolling hills. The lake is especially beautiful during the monsoon season when it is filled to capacity, attracting families, couples, and nature lovers who enjoy relaxing walks, birdwatching, and the refreshing mountain atmosphere."
    },
    {
        title: "Panorama Point",
        description:
            "Panorama Point offers one of the most spectacular sunrise and sunset views in Matheran, with breathtaking panoramic vistas of valleys, mountains, and dense forests stretching across the Sahyadri range. It is a favorite destination for photographers, trekkers, and tourists seeking unforgettable natural scenery throughout the year."
    },
    {
        title: "Echo Point",
        description:
            "Echo Point is a popular viewpoint where visitors can experience the natural echo effect while enjoying magnificent views of the surrounding hills and deep valleys. The pleasant weather, peaceful environment, and scenic landscapes make it one of the most visited attractions for families and sightseeing enthusiasts."
    },
    {
        title: "Louisa Point",
        description:
            "Louisa Point is renowned for its dramatic cliff views, lush green valleys, and clear views of Prabal Fort and nearby waterfalls during the monsoon season. Travelers visiting from Pune often spend time here capturing stunning photographs and enjoying the tranquil atmosphere of Matheran."
    },
    {
        title: "Alexander Point",
        description:
            "Alexander Point is known for its sweeping views of forest-covered hills, winding roads, and picturesque valleys. It is an excellent location for nature lovers who wish to experience Matheran's untouched beauty while enjoying cool mountain breezes and peaceful surroundings away from city life."
    },
    {
        title: "One Tree Hill Point",
        description:
            "One Tree Hill Point is one of Matheran's iconic viewpoints, named after the solitary tree standing on the hilltop. The location offers breathtaking landscapes, scenic trekking routes, and an ideal setting for photography, making it a favorite destination for adventure seekers and nature enthusiasts."
    },
    {
        title: "Porcupine Point",
        description:
            "Porcupine Point, also known as Sunset Point, is famous for its mesmerizing sunset views over the Western Ghats. Visitors gather here every evening to witness the changing colors of the sky while enjoying the peaceful atmosphere, making it one of the most memorable experiences in Matheran."
    },
    {
        title: "Monkey Point",
        description:
            "Monkey Point provides panoramic views of the surrounding mountains and valleys while offering opportunities to observe playful monkeys in their natural habitat. It is a popular stop for tourists looking to enjoy scenic landscapes, fresh mountain air, and a unique wildlife experience."
    },
    {
        title: "Matheran Toy Train",
        description:
            "The historic Matheran Toy Train is a UNESCO-recognized heritage attraction that offers a charming ride through dense forests, tunnels, and scenic hills. Travelers visiting Matheran from Pune often enjoy this nostalgic railway journey, which showcases the hill station's natural beauty from a unique perspective."
    },
    {
        title: "Prabal Fort View",
        description:
            "Prabal Fort View is one of the finest viewpoints in Matheran, offering spectacular views of the historic Prabal Fort and the surrounding Sahyadri mountain ranges. The viewpoint is particularly popular among photographers, trekkers, and travelers who appreciate Maharashtra's rich history combined with breathtaking natural landscapes."
    }
],

  "services": [
    {
      "name": "Pune to Matheran Cab Service",
      "description": "Book Pune to Matheran cab service for a safe and comfortable hill station journey. Available for one-way and round-trip travel with experienced drivers familiar with ghat roads. Choose from AC sedan and SUV options with transparent pricing and flexible pickup points."
    },
    {
      "name": "Pune to Matheran Taxi Fare",
      "description": "Check updated Pune to Matheran taxi fare with clear per km rates and fare breakdown. Pricing depends on vehicle category, trip duration, and travel type (one-way or round trip). Transparent billing ensures no hidden charges."
    },
    {
      "name": "Pune to Matheran One Way Cab",
      "description": "Affordable one way cab from Pune to Matheran ideal for tourists planning return by train or alternate route. Pay only for one-side distance and enjoy flexible departure timing."
    },
    {
      "name": "Pune to Matheran Round Trip Taxi",
      "description": "Round trip taxi service for Pune to Matheran with customizable return schedule. Suitable for weekend getaways, family trips, and group travel with comfortable vehicles and reliable drivers."
    },
    {
      "name": "Pune to Matheran Taxi Booking",
      "description": "Easy Pune to Matheran taxi booking online with instant confirmation. Doorstep pickup from home, hotel, Pune Airport, or railway station for convenient travel planning."
    },
    {
      "name": "Pune to Matheran Taxi Fare Per Km",
      "description": "Know Pune to Matheran taxi fare per km for sedan and SUV vehicles. Clear per kilometer pricing structure helps travelers estimate total travel cost in advance."
    },
    {
      "name": "Pune to Matheran Car Rental",
      "description": "Pune to Matheran car rental options include Swift Dzire, Ertiga, Kia Carens, and Innova Crysta. Suitable for couples, families, and small groups seeking comfortable AC travel."
    },
    {
      "name": "Cheap Cab Pune to Matheran",
      "description": "Budget-friendly Pune to Matheran cab options available without compromising comfort and safety. Ideal for students, solo travelers, and small families planning economical hill station trips."
    },
    {
      "name": "Pune to Matheran Airport Taxi",
      "description": "Direct taxi service from Pune Airport to Matheran for travelers arriving by flight. Timely pickup, luggage assistance, and smooth highway travel ensure a stress-free journey."
    },
    {
      "name": "Outstation Cab Pune to Matheran",
      "description": "Reliable outstation cab Pune to Matheran for weekend escapes and holiday travel. Clean vehicles, professional drivers, and transparent pricing make long-distance travel convenient."
    },
    {
      "name": "Book Pune to Matheran AC Cab",
      "description": "Book fully air-conditioned cab for Pune to Matheran travel. Comfortable seating, smooth ride quality, and experienced chauffeurs ensure pleasant hill station travel in all seasons."
    }
  ],

  "tableData": [
    ["Pune to Matheran Cab Service", "Pune to Matheran Taxi Fare"],
    ["Pune to Matheran One Way Cab", "Pune to Matheran Round Trip Taxi"],
    ["Pune to Matheran Taxi Booking", "Pune to Matheran Taxi Fare Per Km"],
    ["Pune to Matheran Car Rental", "Cheap Cab Pune to Matheran"],
    ["Pune to Matheran Airport Taxi", "Outstation Cab Pune to Matheran"],
    ["Book Pune to Matheran AC Cab", ""]
  ],

  "whychoose": [
    {
      "WhyChooseheading": "Comfortable Hill Station Travel",
      "WhyChoosedescription": "Safe and smooth journey from Pune to Matheran with experienced drivers trained for ghat roads and hill routes."
    },
    {
      "WhyChooseheading": "Transparent Pricing Structure",
      "WhyChoosedescription": "Clear per km rates and fare breakdown including tolls and driver allowance for complete cost transparency."
    },
    {
      "WhyChooseheading": "Multiple Vehicle Options",
      "WhyChoosedescription": "Choose sedan, SUV, or premium MPV vehicles based on group size and comfort preferences."
    },
    {
      "WhyChooseheading": "Flexible One Way & Round Trip Options",
      "WhyChoosedescription": "Book one-way drop or round-trip taxi with customizable return timing to suit your travel plan."
    },
    {
      "WhyChooseheading": "Easy Online Booking & 24/7 Support",
      "WhyChoosedescription": "Quick booking confirmation with customer support assistance for fare details and trip planning."
    }
  ]
}



const faqData = [
  {
    question: 'Does Lotus Cab provide Pune to Matheran cab service?',
    answer: 'Yes, Lotus Cab offers reliable and comfortable Pune to Matheran cab services for one-way and round trips with professional drivers and well-maintained vehicles.',
  },
  {
    question: 'What is the distance between Pune and Matheran by cab?',
    answer: 'The distance from Pune to Matheran is approximately 120–125 km, depending on the route taken. Travel time usually ranges between 3 to 4 hours.',
  },
  {
    question: 'What are the charges for Pune to Matheran cabs?',
    answer: 'Cab charges from Pune to Matheran depend on vehicle type, trip type (one-way or round trip), and travel date. Lotus Cab offers competitive per km pricing with transparent billing.',
  },
  {
    question: 'Can I book a one-way Pune to Matheran cab?',
    answer: 'Yes, Lotus Cab provides affordable one-way cab services from Pune to Matheran, allowing customers to pay only for the drop service.',
  },
  {
    question: 'Which cars are available for Pune to Matheran travel?',
    answer: 'We offer Sedan cars like Dzire and Etios, and SUVs like Ertiga and Innova Crysta, ideal for family trips and group travel to Matheran.',
  },
  {
    question: 'Is Pune to Matheran cab service suitable for weekend trips?',
    answer: 'Absolutely. Lotus Cab provides flexible booking options for weekend getaways to Matheran, making it convenient for couples, families, and corporate groups.',
  },
  {
    question: 'Are toll and parking charges included in the fare?',
    answer: 'Toll, parking, and entry charges (if applicable) are billed separately as per actuals. Lotus Cab ensures clear communication of all additional costs before confirmation.',
  },
  {
    question: 'Can I book a round-trip Pune to Matheran cab for 2 days?',
    answer: 'Yes, we offer multi-day and round-trip packages for Pune to Matheran travel with flexible return schedules.',
  },
  {
    question: 'Are drivers experienced for hill station routes like Matheran?',
    answer: 'Yes, our drivers are experienced in handling hill routes and ensure safe and smooth travel throughout the journey.',
  },
  {
    question: 'How can I book Pune to Matheran cab with Lotus Cab?',
    answer: 'You can book by contacting Lotus Cab directly with your travel details such as pickup location, date, time, and preferred vehicle to receive instant booking confirmation.',
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sandeep More',
    feedback: 'Booked Lotus Cab for Pune to Matheran weekend trip. The journey was smooth and the driver was very polite. Great service at a reasonable price.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Neha Kulkarni',
    feedback: 'Excellent cab service from Pune to Matheran. Clean car, on-time pickup, and transparent fare. Highly recommend Lotus Cab for hill station travel.',
    rating: 5,
  },
];





































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];





const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Matheran Cabs",
"image": "https://lotuscab.com/assets/images/pune-to-matheran-cabs.jpg",
"description": "Book Pune to Matheran Cabs with Lotus Cab for affordable, safe, and comfortable travel. One way and round trip taxi service with Sedan, SUV, Hatchback, and AC cabs available 24x7 with instant booking confirmation.",
"brand": {
"@type": "Brand",
"name": "Lotus Cab"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "6238"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹11/Km",
"availability": "https://schema.org/InStock",
"url": "https://lotuscab.com/pune-to-matheran-cabs"
}
};







  return (
    <div>
      



<Helmet>
  <title>Pune to Matheran Cabs | One Way & Round Trip Taxi Service | +91 8767592195</title>

<meta
 name="description"
 content="Book Pune to Matheran Cabs with Lotus Cab at affordable fares. One way and round trip taxi service with Sedan, SUV, Hatchback, and AC cabs, professional drivers, instant booking, and 24x7 customer support."
/>

<meta
 name="keywords"
 content="Pune to Matheran Cabs, Pune to Matheran Cab, Pune to Matheran Taxi, Pune to Matheran Taxi Service, Matheran Cab from Pune, One Way Cab Pune to Matheran, Round Trip Cab Pune to Matheran, Outstation Cab Pune to Matheran, Pune to Matheran Car Rental, Affordable Pune to Matheran Cab, Cheap Pune to Matheran Taxi, Online Pune to Matheran Cab Booking, Sedan Cab Pune to Matheran, SUV Cab Pune to Matheran, AC Cab Pune to Matheran, Best Pune to Matheran Cab, Lotus Cab Pune"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>







 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/76.png' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomatherancabs;